import get from "lodash/get";
import {
    processOdooInvoiceClientLoading,
    processOdooInvoiceClientReject,
    processOdooInvoiceClientRequest,
    processOdooInvoiceClientSuccess,
    processOdooInvoiceClientReset,
} from "../../actions/invoiceClient/processOdoo";

export const processOdooInvoiceClient = (InvoiceId) => async (dispatch, getState) => {
    dispatch(processOdooInvoiceClientLoading());
    try {
        const { data } = await processOdooInvoiceClientRequest(InvoiceId, getState);
        dispatch(processOdooInvoiceClientSuccess(data));
    } catch (error) {
        dispatch(processOdooInvoiceClientReject(get(error, "response.data", error)));
    } finally {
        setTimeout(() => { dispatch(processOdooInvoiceClientReset()); }, 3000);
    }
    return Promise.resolve();
};
